import { Badge } from 'evergreen-ui';

import { useListOrdersWithIssuesQuery } from './threads.api';

// Tab title for the Dashboard's "Probleme" tab. Reads the count off the
// shared RTK Query cache so it dedupes with the OrdersWithIssues widget's
// own fetch (one request feeds both).
export function ProblemsTabLabel() {
    const { data } = useListOrdersWithIssuesQuery(
        { page: 1, limit: 10 },
        { pollingInterval: 60000 },
    );

    const count = data?.pagination.totalCount ?? 0;

    return (
        <span>
            Probleme
            {count > 0 && (
                <Badge color="red" marginLeft={6}>
                    {count}
                </Badge>
            )}
        </span>
    );
}
